<script setup lang="ts">

import CarbucksProtectFeatures from './Components/CarbucksProtectFeatures.vue';

</script>

<template>

    <Page>
   
        <div class="grid grid-cols-2 justify-center items-center">


            <div class="flex flex-col items-center gap-4 pt-12">
            
                <Image src="/protect-logo.png"
                    class="w-3/5 -top-4" 
                />

                <Image
                    src="/images/shared/WhatIsCarbucks/carbucks-protect.png"
                    class="w-[50vw] md:w-full max-w-[420px] mb-6 mx-auto -top-8 2xl:-mb-2"
                    floor-shadow
                />

                <Video class="scale-125 -mt-20"
                    src="~/video/protect.mp4" 
                    title="Watch Video" 
                />

            </div>

            <CarbucksProtectFeatures />

        </div>

    </Page>

</template>